var ToolOptionType = {
    BUTTON              : 'button',
    SELECTBOX           : 'selectbox',
};

module.exports = ToolOptionType;
